export type Game = {
  id: string;
  categoryName: string;
  name: string;
  description: string;
  bannerAssetUrl: string;
  serpScore: number;
  iconAssetUrl: string;
  tileAssetUrl: string;
  bannerImageRoundedUrl: string;
  smallSquareRounded_34x34: string;
  smallCircular_46x46: string;
  mediumSquareRounded_128x112: string;
  smallCircular_28x28: string;
  binge_326x605: string;
  predominantColor: string;
  carriers: Carrier[];
  ctaUrl: string;
  rating: string;
  livePlayersCount: null;
};

export type GameCDS = {
  // sys: Sys;
  // gameName: string;
  // description: string;
  // nostraCategory: string;
  // score: number;
  // rating: number;
  // images: Images;
  // players: null;
  // gameVersionCollection: GameVersionCollection;
  id: string;
  categoryName: string;
  name: string;
  description: string;
  score: number;
  rating: string;
  ctaUrl: string;
  iconImage: string;
  bannerImage: string;
  cardImage: string;
  storyImage: string;
};

export type GameVersionCollection = {
  items: Item[];
};

export type Item = {
  description: null;
  gameLink: string;
};

export type Images = {
  'Icon Image': IconImage;
  'Banner Image': BannerImage;
  'Card Thumbnail': CardThumbnail;
  'Story Thumbnail': BannerImage;
};

export enum GameImages {
  IconImage = 'Icon Image',
  BannerImage = 'Banner Image',
  CardThumbnail = 'Card Thumbnail',
  StoryThumbnail = 'Story Thumbnail'
}

export type BannerImage = {
  original: string;
};

export type CardThumbnail = {
  original: string;
  smallCircular_28x28: string;
  smallCircular_46x46: string;
  smallCircular_54x54: string;
};

export type IconImage = {
  original: string;
  smallSquare_66x66: string;
  smallSquareRounded_34x34: string;
  mediumSquareRounded_128x112: string;
};

export type Sys = {
  id: string;
};

export enum Carrier {
  Moto = 'Moto',
  Standalone = 'Standalone',
  Tracfone = 'Tracfone',
  Verizone = 'Verizone'
}

export type SwishGamesCategoriesCollection = {
  total: number;
  items: GameCategory[];
};

export type GameCategory = {
  categoryName: string;
  icon: Icon;
};

export type Icon = {
  url: string;
};

export type SwishGamesCollection = {
  total: number;
  items: GameCDS[];
};

export type SwishGamesCuratedListCollection = {
  total: number;
  items: SwishGamesCuratedListCollectionItem[];
};

export type SwishGamesCuratedListCollectionItem = {
  gamesCollection: GamesCollection;
};

export type GamesCollection = {
  total: number;
  items: GameCDS[];
};

export enum GamesCategory {
  Action = 'Action',
  Adventure = 'Adventure',
  Casual = 'Casual',
  Popular = 'Popular',
  RecentlyPlayed = 'Recently Played',
  Trending = 'Trending',
  TopThree = 'Top',
  Board = 'Board',
  CardAndSlot = 'Card & Slot',
  Puzzle = 'Puzzle',
  Racing = 'Racing',
  Sports = 'Sports'
}

export type RecentlyPlayedGame = {
  id: string;
  name: string;
  description: string;
  rating: string;
  tileAssetUrl: string;
  logoAssetUrl: string;
  nostraCategory: string;
  ctaUrl: string;
};
